import { createAxiosClient } from "@ntg/component-library/utilities";
import { useMutation } from "@tanstack/react-query";

const apiClient = createAxiosClient("D365FO");

interface ICommitServiceOrderPayload {
    forInvoice: boolean;
    serviceOrderID: number;
}

async function commitServiceOrder(
    payload: ICommitServiceOrderPayload,
): Promise<string> {
    const response = await apiClient.post<string>(
        "/FunctionAppsStarter/CommitServiceOrder",
        {
            serviceOrderID: payload.serviceOrderID,
            forInvoice: payload.forInvoice,
        },
        { headers: { "Content-Type": "application/json" } },
    );
    return response.data;
}

export function useCommitServiceOrderMutation() {
    return useMutation({
        mutationFn: commitServiceOrder,
    });
}
